import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Router from './router.js';
import registerServiceWorker from './registerServiceWorker';
// import {
//     whichSystem
// } from '../../utils/utils';

// 开放js方法
window.cancelCreateProgram = (obj) => {
    // setTimeout(() => {
    // alert(obj);
    return '1';
    // }, 500);
}

ReactDOM.render(<Router />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js